import React, { useState, useEffect } from "react";
import { FaHome, FaTrash, FaEdit } from "react-icons/fa";
import { FiAlignJustify } from "react-icons/fi";
import UserList from "./UserList";
import Edit from "./Edit"

const ToDo = () => {
  const [Tasks, setListTask] = useState(() => {
    const savedTasks = localStorage.getItem("todoTasks");
    return savedTasks ? JSON.parse(savedTasks) : [];
  });

  const [theme, setTheme] = useState("bg-dark");
  const [inpValue, setInputVal] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [status, setStatus] = useState(false);

  const [deletedTasks, setDeletedTasks] = useState([]);

  const checkStatus = () => {
    setStatus(!status);
  };
  
  
  useEffect(() => {
    localStorage.setItem("todoTasks", JSON.stringify(Tasks));
  }, [Tasks]);

  const changeTheme = (newTheme) => {
    setTheme(newTheme);
  };

  const handleInputVal = (e) => {
    setInputVal(e.target.value);
  };

 const handleButton = () => {
  const trimmedValue = inpValue.trim();
  if (!trimmedValue) return;

  let updatedTasks = [...Tasks];

  if (editingIndex !== null) {
    const isDuplicate = updatedTasks.some(
      (task, index) =>
        index !== editingIndex &&
        task.toLowerCase() === trimmedValue.toLowerCase()
    );

    if (isDuplicate) {
      window.alert("This task already exists in your list.");
      return;
    }

    updatedTasks[editingIndex] = trimmedValue;
    setEditingIndex(null);
  } else {
    const taskExists = updatedTasks.some(
      (task) => task.toLowerCase() === trimmedValue.toLowerCase()
    );

    if (taskExists) {
      window.alert("Task already exists!");
      return;
    }

    updatedTasks.push(trimmedValue);
  }

  setListTask(updatedTasks);
  localStorage.setItem("todoTasks", JSON.stringify(updatedTasks));
  setInputVal("");
};

  const handleDeletTask = (index) => {
    const taskToDelete = Tasks[index];

    setDeletedTasks((prevDeletedTasks) => [...prevDeletedTasks, taskToDelete]);

    const deleteTask = Tasks.filter((_, i) => i !== index);
    setListTask(deleteTask);
  };

  const handleClearAll = () => {
    setListTask([]);

    setDeletedTasks([]);
    localStorage.clear();
  };

  const handleEditTask = (index, taskText) => {
    setEditingIndex(index);
    setInputVal(taskText);
  };

  const handleUpdateTask = () => {
  if (editingIndex === null) return;

  const updatedTasks = [...Tasks];
  updatedTasks[editingIndex] = inpValue;

  setListTask(updatedTasks);
  localStorage.setItem("todoTasks", JSON.stringify(updatedTasks));

  setEditingIndex(null);
  setInputVal("");
};


  return (
    <>
      <div className={`${theme}`} style={{ minHeight: "100vh" }}>
        <nav
          className={`navbar navbar-expand-md `}
        >
          <div className="container">
            <a className={`navbar-brand fw-bold fs-2 ${theme === "bg-dark" ? "text-white": "text-black"}`} href="#">
              TODO <span style={{ color: "#0af80aff" }}>APP</span>
            </a>

            <div className="d-block d-md-none">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <FiAlignJustify className="fs-2 fw-bold" />
              </button>
            </div>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className={`nav-link active ${theme === "bg-dark" ? "text-white": "text-black"}`} href="#hero">
                    <FaHome className="me-1" /> Home
                  </a>
                </li>
                
              </ul>
              <div className="d-flex gap-2 ms-lg-3 mt-3 mt-lg-0">
                <button
                  onClick={() => changeTheme("bg-dark")}
                  className="btn btn-dark border border-light "
                ></button>
                <button
                  onClick={() => changeTheme("bg-light")}
                  className="btn btn-light border "
                ></button>
                <button
                  onClick={() => changeTheme("bg-secondary")}
                  className="btn btn-secondary border "
                ></button>
              </div>
            </div>
          </div>
        </nav>

        <div className="todo-tasks" id = "hero">
          <div className="container py-5">
            <div className="row flex-column align-items-center justify-content-center">
              <div className="col-lg-6 col-md-8 col-12 mb-3">
                <h1
                  className={`text-center mb-5 ${theme === "bg-dark" ? "text-white": "text-black"}`}
                  id="Users"
                >
                  Just <span style={{ color: "#32CD32" }}>DO It</span>...
                </h1>
                <div className="input-group">
                  <input
                    type="text"
                    value={inpValue}
                    onChange={handleInputVal}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleButton();
                    }}
                    className="form-control"
                    style={{ minWidth: "200px", maxWidth: "500px" }}
                    placeholder="add Task"
                  />
                  <button onClick={handleButton} className="btn btn-success">
                    {editingIndex !== null ? "Update" : "Add"}
                  </button>
                </div>
              </div>
              {Tasks.length > 0 && (
                <div
                  className={`col-lg-6 col-md-8 col-12 bg-secondary py-2 px-4 rounded-2 ${theme === "bg-dark" ? "bg-white": "bg-light"}`}
                >
                  <h1 className={`text-center text-black mb-4 `} id="User">
                    User Tasks....
                  </h1>
                  <ul className="list-unstyled">
                    {Tasks.map((task, index) => (
                      <li
                        onClick={checkStatus}
                        key={index}
                        className={`${
                          status ? "line-effect" : ""
                        } d-flex justify-content-between align-items-center fs-6 py-2 px-3 mb-2 rounded-2`}
                        style={{
                          backgroundColor: "rgba(0,0,0,1.2)",
                          color: "white",
                        }}
                      >
                        {task}
                        <div className="d-flex gap-2">
                          <button
                            onClick={() => handleEditTask(index, task)}
                            className="btn btn-warning btn-sm"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() => handleDeletTask(index)}
                            className="btn btn-danger btn-sm"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div className="d-grid mt-3">
                    <button onClick={handleClearAll} className="btn btn-danger">
                      Clear All Tasks
                    </button>
                  </div>
                </div>
              )}
              {editingIndex !== null && (
             <Edit
             value={inpValue}
             setValue={setInputVal}
             onClose={() => {
               setEditingIndex(null);
               setInputVal("");
             }}
             onSave={handleUpdateTask}
           />
            )}

            </div>
          </div>
        </div>
        <UserList deletedTasks={deletedTasks}></UserList>
      </div>
    </>
  );
};

export default ToDo;
